import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormCanvas } from 'components/form-fields';
import { ShowHide } from 'components/layout';

const replacedUnsignedMessage = "Not signed by the employee - replaced by a later edit.";

// One set of signatures held against a completed review: the manager's and the employee's, read
// side by side; the section that holds a set names it. A set inside its own section leaves the
// gap below it to that section, so spaced is false there. When the employee signs separately
// (by email or in the app), a set replaced by a later edit before they signed it says so in the
// employee's column, and a current set still waiting on them shows awaitingMessage in an empty,
// outlined box there. A physical sign-off records no employee signature, so its sets never claim
// the employee did not sign.
export function ReviewSignatureSet(
    {
        signatureSet = null,
        employeeName = null,
        replaced = false,
        employeeSignsSeparately = false,
        awaitingMessage = null,
        spaced = true
    }
) {

    const managerSignature = signatureSet?.managerSignature;
    const employeeSignature = signatureSet?.employeeSignature;
    const employeeSigned = signatureSet?.employeeSignedOffDate != null;

    return (
        <Fragment>
            {/* Each column is its label followed by its box. A label that wraps pushes only its own
                box down, so both labels are held to the name alone. */}
            <div className={classNames("completed-review-signatures", { "spacer-bottom": spaced })}>
                <ShowHide
                    evaluator={managerSignature != null}
                    show={(
                        <div>
                            <p className="spacer-bottom-medium"><span className="bold">Manager</span> - {signatureSet?.managerSignedBy}</p>
                            <FormCanvas
                                readOnly
                                imageSource={managerSignature?.url}
                                width="100%"
                                headingText={null}
                                helperText={null}
                                showDate
                                signedDate={signatureSet?.managerSignedDate}
                            />
                        </div>
                    )}
                />
                <ShowHide
                    evaluator={employeeSigned || (replaced && employeeSignsSeparately) || awaitingMessage != null}
                    show={(
                        <div>
                            <p className="spacer-bottom-medium"><span className="bold">Employee</span> - {employeeName}</p>
                            <ShowHide
                                evaluator={employeeSigned && employeeSignature != null}
                                show={(
                                    <FormCanvas
                                        readOnly
                                        imageSource={employeeSignature?.url}
                                        width="100%"
                                        headingText={null}
                                        helperText={null}
                                        showDate
                                        signedDate={signatureSet?.employeeSignedOffDate}
                                    />
                                )}
                            />
                            <ShowHide
                                evaluator={!employeeSigned && replaced}
                                show={(
                                    <p className="bp6-text-muted">{replacedUnsignedMessage}</p>
                                )}
                            />
                            <ShowHide
                                evaluator={!employeeSigned && !replaced && awaitingMessage != null}
                                show={(
                                    <div className="completed-review-signature-awaiting">
                                        <span className="bp6-text-muted">{awaitingMessage}</span>
                                    </div>
                                )}
                            />
                        </div>
                    )}
                />
            </div>
        </Fragment>
    );
}

ReviewSignatureSet.propTypes = {
    signatureSet: PropTypes.object,
    employeeName: PropTypes.string,
    replaced: PropTypes.bool,
    employeeSignsSeparately: PropTypes.bool,
    awaitingMessage: PropTypes.string,
    spaced: PropTypes.bool
};
